import {
  BodyText,
  Flex,
  Heading,
  RadioGroup,
  RadioTile,
} from '@utilitywarehouse/hearth-react';
import { FormikProps, useFormikContext } from 'formik';

import { useFieldProps } from '@hooks/useFieldProps';
import { BooleanSelection } from '@src/types/index';
import { YourDetailsFormValues } from '@src/types/yourDetails';
import { useTrackSignupBroadbandDependencyQuestionAnswered } from '@tracking/trackingEvents.ts';

const EmergencyCalls = () => {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    submitCount,
    setFieldValue,
  }: FormikProps<YourDetailsFormValues> = useFormikContext();
  const getFieldProps = useFieldProps<YourDetailsFormValues>({
    values,
    errors,
    handleChange,
    handleBlur,
    touched,
    submitCount,
  });
  const trackSignupBroadbandDependencyQuestionAnswered =
    useTrackSignupBroadbandDependencyQuestionAnswered();
  return (
    <Flex asChild direction="column" spacing="lg">
      <section>
        <Heading size="sm" as="h3">
          Making emergency calls
        </Heading>
        <BodyText>
          As digital home phone relies on your broadband connection you would
          lose your home phone service in the event of an outage or power cut.
          Please answer these questions so we can make sure this product is
          right for you.
        </BodyText>

        <RadioGroup
          {...getFieldProps('broadbandEmergMonitDevice')}
          direction="row"
          label="Do you have any devices connected to your home phone that automatically alert a health monitoring service?"
          helperText="This might include a personal alarm pendant, fall detector or careline device."
          className="details__radioField"
          data-testid="broadbandEmergMonitDevice"
          onValueChange={(val) => {
            setFieldValue('broadbandEmergMonitDevice', val);
            trackSignupBroadbandDependencyQuestionAnswered({
              question_number: 1,
              answered_yes: val === BooleanSelection.Yes,
            });
          }}
        >
          <RadioTile
            data-testid="broadbandEmergMonitDeviceYes"
            value={BooleanSelection.Yes}
            label="Yes"
            id="broadbandEmergMonitDeviceYes"
          />
          <RadioTile
            data-testid="broadbandEmergMonitDeviceNo"
            value={BooleanSelection.No}
            label="No"
            id="broadbandEmergMonitDeviceNo"
          />
        </RadioGroup>

        {values.broadbandEmergMonitDevice === BooleanSelection.No && (
          <RadioGroup
            {...getFieldProps('broadbandEmergAlt')}
            direction="row"
            label="Would you need your digital home phone to make an emergency call during a power cut?"
            className="details__radioField"
            data-testid="broadbandEmergAlt"
            onValueChange={(val) => {
              setFieldValue('broadbandEmergAlt', val);
              trackSignupBroadbandDependencyQuestionAnswered({
                question_number: 2,
                answered_yes: val === BooleanSelection.Yes,
              });
            }}
          >
            <RadioTile
              data-testid="broadbandEmergAltYes"
              value={BooleanSelection.Yes}
              label="Yes"
              id="broadbandEmergAltYes"
            />
            <RadioTile
              data-testid="broadbandEmergAltNo"
              value={BooleanSelection.No}
              label="No"
              id="broadbandEmergAltNo"
            />
          </RadioGroup>
        )}
      </section>
    </Flex>
  );
};

export { EmergencyCalls };
